import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/logo.png";
import ContactModal from "./ContactModal";
import { useGetMainQuery } from "services/clientApi";

import "./sidebar.scss";

const Sidebar = ({ isAdmin }) => {
  const navigate = useNavigate();

  const [openModalEmail, setOpenModalEmail] = useState(false);
  const [openModalPhone, setOpenModalPhone] = useState(false);
  const [contactEmail, setContactEmail] = useState("");
  const {
    data: main,
    isLoading: loading,
    isError: error,
  } = isAdmin ? "" : useGetMainQuery();

  const triggerModal = (el) => {
    setOpenModalEmail(!openModalEmail);
    setContactEmail(el);
  };
  const triggerModalPhone = (el) => {
    setOpenModalPhone(!openModalPhone);
  };

  const sideBarElements = [
    {
      name: "Home",
      className: "icon-dashboard",
      path: "/",
      icon: "fa-solid fa-house-user",
    },

    {
      name: "Transactions",
      className: "icon-transactions-v2",
      path: "/transactions",
      icon: "fa-solid fa-right-left",
    },

    {
      name: "Exchange",
      className: "fa-solid fa-arrows-rotate",
      path: "/exchange",
      icon: "fa-solid fa-arrows-rotate",
    },

    {
      name: "Investments",
      className: "icon-projects",
      path: "/investments",
      icon: "fa-solid fa-chart-line",
    },
    {
      name: "Profile",
      className: "icon-projects",
      path: "/profile",
      icon: "fa-regular fa-user",
    },
    {
      name: "Schedule",
      className: "icon-projects",
      path: "/schedule",
      icon: "fa-regular fa-calendar-days",
    },
  ];
  const sideBarElementsAdmin = [
    {
      name: "Home",
      className: "icon-dashboard",
      path: "/admin/home",
      icon: "fa-solid fa-house-user",
    },

    {
      name: "Transactions",
      className: "icon-transactions-v2",
      path: "/admin/transactions",
      icon: "fa-solid fa-money-bill-transfer",
    },

    {
      name: "Profile",
      className: "icon-projects",
      path: "/admin/profile",
      icon: "fa-regular fa-user",
    },
    {
      name: "Settings",
      className: "icon-projects",
      path: "/settings",
      icon: "fa-solid fa-gears",
    },
    {
      name: "Calendar",
      className: "icon-projects",
      path: "/calendar",
      icon: "fa-regular fa-calendar-days",
    },
  ];

  const pathController = window.location.pathname;

  return (
    <div
      className=" w-10 border 
        sidebar-cont  shadow-sm  bg-white"
    >
      <div className="text-center mt-4">
        <span className="brand-logo-frame" style={{ "--brand-logo-width": "210px", "--brand-logo-height": "58px" }}>
          <img src={Logo} alt="Banque Artesia Nederland N.V." />
        </span>
      </div>
      <div className="mt-5">
        {(isAdmin ? sideBarElementsAdmin : sideBarElements).map(
          (item, index) => (
            <div className="mb-3">
              <div
                key={index}
                role="button"
                className={` ${pathController === item.path
                  ? "side-elements-selected"
                  : "side-elements"
                  }`}
              >
                <div className="text-center position-relative ">
                  <div
                    className={`${pathController === item.path ? "selected-rounded " : ""
                      }`}
                  >
                    <li
                      className={`list-group-item fw-bold list-group-item-action text-center rounded  border-0 ${pathController === item.path ? "" : ""
                        }`}
                    >
                      <div
                        className={`  ${pathController === item.path
                          ? "background-active"
                          : "background-non-active"
                          }`}
                      >
                        <div
                          onClick={() => navigate(item.path)}
                          className="text-center "
                          style={{ fontSize: "22px" }}
                        >
                          <div>
                            <div className="w-100 text-center">
                              <i
                                style={{
                                  color: `${pathController === item.path
                                    ? "white"
                                    : "rgb(98, 109, 126)"
                                    }`,
                                  margin: "auto",
                                  fontSize: "25px",
                                }}
                                className={` ${item.icon}`}
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </div>{" "}
                </div>
                <div className="w-100 text-center ">
                  <h5 style={{ fontSize: "15px" }} className="light-grey">
                    {item.name}
                  </h5>
                </div>
              </div>
            </div>
          )
        )}
      </div>
      <div className="side-footer position-relative">
        <div className="w-100">
          {openModalEmail ? (
            <div className="rounded email-popup  bg-white border text-center ">
              <h5 className="mt-1 text-grey">Email</h5>
              <h5 className="m-3 ">{main?.company?.email}</h5>
              <div className="w-100 text-end p-3">
                <button onClick={triggerModal} className="btn btn-primary">
                  Close
                </button>
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            // onClick={() => triggerModal("email")}
            type="button"
            className="email-circle  m-auto shadow"
            data-container="body"
          >
            <i
              // onClick={triggerModal}
              className="fa-regular text-custom-orange-ub fa-envelope fs-2"
            />
          </div>
          {/* <p className="">info@Banque Artesia Nederland N.V..com</p> */}
        </div>
        <div className="w-100 mt-4">
          {openModalPhone ? (
            <div className="rounded email-popup  bg-white border text-center ">
              <h5 className="mt-1 text-grey">Custom Service</h5>
              {/* <h4 className="m-3">+44 1315 070 203</h4> */}
              <h4 className="m-3">
                <a href="tel:+31202417136">+31 2024 171 36</a>
              </h4>
              <div className="w-100 text-end p-3">
                <button onClick={triggerModalPhone} className="btn btn-primary">
                  Close
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
          <div
            onClick={main?.company?.id === 72 ? "" : triggerModalPhone}
            type="button"
            className="email-circle  m-auto shadow"
          >
            <i className="fa-solid fa-phone fs-2 text-custom-orange-ub" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
